export const CSRF_HEADER_NAME = 'X-CSRF-TOKEN';
export const USER_CSRF_INTERCEPTOR_HEADER_NAME = 'use-csrf-interceptor';
